import { render, staticRenderFns } from "./shopbTable.vue?vue&type=template&id=092b7643&scoped=true&"
import script from "./shopbTable.vue?vue&type=script&lang=js&"
export * from "./shopbTable.vue?vue&type=script&lang=js&"
import style0 from "./shopbTable.vue?vue&type=style&index=0&id=092b7643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092b7643",
  null
  
)

export default component.exports